import { alpha } from '@mui/material/styles';

export const documentStatusChipSx = status => theme => {
  const palette = ['AUSGESTELLT', 'FREIGEGEBEN'].includes(status) ? theme.palette.success
    : status === 'STORNIERT' ? theme.palette.error : null;
  const color = palette?.main || theme.palette.grey[700];
  return {
    bgcolor: alpha(color, 0.12),
    color: palette?.dark || theme.palette.grey[800],
    fontWeight: 500,
  };
};
